import PrivacyPage from 'pages/Policy';
import { lazy } from 'react';
import { NoMatch } from 'shared';

const Home = lazy(() => import('../pages/Home'));
const Applications = lazy(() => import('../pages/Applications'));
const Products = lazy(() => import('../pages/Products'));
const News = lazy(() => import('../pages/News'));
const WhiStleblowing = lazy(() => import('../pages/WhiStleblowing'));
const Privacy = lazy(() => import('../pages/Policy'));
const Cookie = lazy(() => import('../pages/Cookie'));

export const routes = [
  { exact: true, path: '/', component: <Home /> },
  { exact: true, path: '/who-we-are', component: <Home scrollTo="whoweare" /> },
  { exact: true, path: '/contacts', component: <Home scrollTo="contacts" /> },

  { exact: true, path: '/applications', component: <Applications /> },
  {
    exact: true,
    path: '/energyDataCenter',
    component: <Applications scrollTo="energyDataCenter" />,
  },
  {
    exact: true,
    path: '/energyMaritime',
    component: <Applications scrollTo="energyMaritime" />,
  },
  { exact: true, path: '/Power', component: <Applications scrollTo="power" /> },

  { exact: true, path: '/products', component: <Products /> },
  {
    exact: true,
    path: '/stationary',
    component: <Products scrollTo="stationary" />,
  },
  {
    exact: true,
    path: '/maritime',
    component: <Products scrollTo="maritime" />,
  },

  { exact: true, path: '/news', component: <News /> },
  /* { exact: true, path: '/whistleblowing', component: <WhiStleblowing /> },

  { exact: true, path: '/privacy', component: <Privacy /> },
  { exact: true, path: '/cookie', component: <Cookie /> }, */

  // fallback 404
  { exact: false, path: '*', component: <NoMatch /> },
];
